/* eslint-disable camelcase */
import { ScoreDataResult } from 'src/apps/dashboard/services/queries/score/helpers/transformResults';
import { IFilterOptions } from 'src/common/helpers/DataFilterHelper';
import { LabelsExcludedFromDashboard } from 'src/common/types/ConfigurationTypes';

import { MobileScoreDataQuery, MobileScoreDataQueryVariables } from '../MobileScoreData.generated';

import { buildMobileBaseVariables } from './mobileFilterVariableBuilder';

export const buildMobileScoreDataVariables = (
	days: number,
	filters?: IFilterOptions,
	labelsExcludedFromDashboard?: LabelsExcludedFromDashboard
): MobileScoreDataQueryVariables => ({
	days,
	...buildMobileBaseVariables(filters, labelsExcludedFromDashboard)
});

export const transformMobileScoreDataResults = (
	rawResults: MobileScoreDataQuery
): ScoreDataResult => {
	const lastUpdatedCandidates = [
		rawResults.mfaDailyIssues?.[0]?.run_updated_at_max,
		rawResults.msdkDailyIssues?.[0]?.run_time_max
	]
		.filter(Boolean)
		.map((value) => new Date(value as string).getTime());

	return {
		scores: [],
		lastUpdatedAt: lastUpdatedCandidates.length > 0 ? Math.max(...lastUpdatedCandidates) : 0
	};
};
